import React from "react";
import "../Styles/header.css";

function Header() {
  return (
    <div className="header">
      <p className="title">Application d'exemple React Open Street Map</p>
    </div>
  );
}

export default Header;
